import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Epic and Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Change Impacts',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Build / Functional',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctionalTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Data Migration',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'dataMigrationTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Reporting & Analytics',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalyticsTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Change Management',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'changeManagementTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Data Integration',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegrationTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Technical',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'technicalDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'technicalDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'technicalBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'technicalGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'technicalMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'technicalGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'technicalProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'technicalStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'technicalBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'technicalTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'technicalTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Project Management',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'projectManagementTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Marketing Cloud',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Discovery',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudDiscovery',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Design',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudDesign',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Bio Demo',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudBioDemo',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Gifts & Pledges',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudGiftsAndPledges',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Memberships',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudMemberships',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Giving Societies',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudGivingSocieties',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Research & Management',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudProspectResearchAndManagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Backlog',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudBacklog',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Testing',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudTesting',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Training',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloudTraining',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Phase',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    technicalDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsDesign: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Design',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsBacklog: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Backlog',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsBioDemo: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Bio Demo',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsTesting: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Testing',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsTraining: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Training',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsDiscovery: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Discovery',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsMemberships: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Memberships',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsStewardship: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Stewardship',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsGiftsAndPledges: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Gifts & Pledges',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsGivingSocieties: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Giving Societies',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    technicalProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Technical',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigrationProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Migration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloudProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Marketing Cloud',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctionalProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Build / Functional',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegrationProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Data Integration',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagementProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Change Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagementProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Project Management',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalyticsProspectResearchAndManagement: {
      filter: {
        and: [
          {
            '=': [
              {
                '@.': '!functional_area',
              },
              'Reporting & Analytics',
            ],
          },
          {
            '=': [
              {
                '@.': '!phase',
              },
              'Prospect Research & Management',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
